
import React, {FC} from 'react';
import ApptDetails, {ApptProps} from 'components/ApptDetails2';
import Button from 'components/Button';
import {Routes} from 'constants/index';
import {Link} from 'gatsby';
import {usePermissions} from 'hooks/usePermissions';
import {createRedirect} from 'utils/auth';

import * as styles from './styles.module.scss';

type CheckApptProps = {
	appt: ApptProps
	onPricing: () => void
}

const CheckAppt: FC<CheckApptProps> = ({appt, onPricing}) => {
	const {auth} = usePermissions();
	return (
		<div className={styles.check}>
			<ApptDetails
				className={styles.appt}
				details={appt}
			/>
			<Button variant='primary' onClick={onPricing}>
				Continue to pricing
			</Button>
			{!auth.isValidUser() && (
				<p>
					Already have credits? {(
						<Link to={createRedirect(Routes.signIn)}>
							Sign in
						</Link>
					)}
				</p>
			)}
		</div>
	);
};

export default CheckAppt;
